const shell = {
  adminWorkspace: '后台工作区',
  brand: {
    admin: 'AI Hub 管理台',
    user: 'Avaca AI Hub',
  },
  adminNavigation: {
    adminAccounts: '管理员账号',
    agent: 'Agent',
    adpCredentials: 'ADP 凭据',
    wecomIdentityProfiles: '企业微信身份源',
    appEvals: '应用评测',
    appReview: '上下架审核',
    appTags: '应用标签',
    applications: '应用管理',
    apps: '应用列表',
    branding: '品牌设置',
    businessNavigation: '业务导航',
    coreAgent: 'Core Agent',
    conversationLogs: 'Dify 对话日志',
    credentials: '凭据管理',
    idp: 'IDP',
    idpClientScopes: 'Client Scopes',
    idpClients: 'Clients',
    idpProvider: 'Provider 配置',
    idpResources: 'OAuth Resources',
    departments: '部门管理',
    members: '成员账号',
    mcp: 'MCP',
    modelCallLogs: '调用日志',
    modelGateway: '模型网关',
    modelKeys: '模型分发',
    modelProvider: '模型注册',
    organization: '组织管理',
    organizationSync: '同步设置',
    overview: '总览',
    settings: '系统设置',
    sso: '成员认证',
    statistics: '数据统计',
    usageDashboard: '使用看板',
  },
  language: {
    english: 'English',
    simplifiedChinese: '简体中文',
  },
  mobile: {
    closeNavigation: '关闭导航',
    openNavigation: '打开导航',
  },
  sheet: {
    close: '关闭底部面板',
  },
  sidebar: {
    collapse: '收起侧边栏',
    expand: '展开侧边栏',
  },
  userNavigation: {
    appSearch: {
      empty: '输入关键词搜索应用',
      label: '搜索应用',
      loading: '正在搜索应用',
      noMatches: '没有匹配应用',
      placeholder: '搜索应用...',
    },
    appMarket: '应用中心',
    coreAgent: 'Hub Agent',
    history: '历史会话',
    newChat: '新建会话',
    noQuickApps: '暂无应用',
    quickApps: '我的应用',
    quickAppsLoading: '正在加载应用',
    recentConversations: '最近会话',
  },
  userMenu: {
    adminProfile: '个人设置',
    fallbackName: '用户',
    language: '语言',
    logout: '退出登录',
    mySettings: '我的设置',
    settings: '设置',
    toggle: '打开用户菜单',
  },
  workspace: '工作区',
}

export default shell
